import { NEUTRAL_TONE_MAP } from './toneMap';
import type { MapartSettings } from './types';

export function defaultSettings(): MapartSettings {
  return {
    selection: {},
    staircase: 'off',
    support: 'gravity',
    supportBlock: { id: 4, meta: 0 },
    noobline: true,
    dither: 'none',
    serpentine: true,
    metric: 'de2000',
    ditherStrength: 1,
    toneMap: { lightness: true, gamut: true },
    exportMode: 'whole',
    alphaThreshold: 128,
  };
}

/**
 * A project saved before a setting existed comes back without it, and `reconcile` would then leave
 * the store with an undefined where the UI reads a value. Every load goes through here.
 */
export function normaliseSettings(stored: Partial<MapartSettings> | undefined): MapartSettings {
  const base = defaultSettings();
  if (!stored) return base;
  return {
    ...base,
    ...stored,
    supportBlock: { ...base.supportBlock, ...(stored.supportBlock ?? {}) },
    toneMap: { ...NEUTRAL_TONE_MAP, ...base.toneMap, ...(stored.toneMap ?? {}) },
  };
}
